import React, { useMemo } from 'react';
import { HOTELS, REPORTS, SERVICE } from 'src/constants';
import { usePage, useLanguage } from 'src/hooks';
import { useAccountState } from 'src/services/auth';
import { Link } from 'src/components/general';
import { ReactComponent as HotelsSvg } from 'src/images/hotels.svg';
import { ReactComponent as ReportsSvg } from 'src/images/reports.svg';
import { ReactComponent as ServiceSvg } from 'src/images/service.svg';
import styles from './mainPageStyle.module.scss';

export const MainPage = () => {
  const {
    access: { accessMap, hotelsPageAccess },
  } = usePage();
  const { user } = useAccountState();
  const { t } = useLanguage();

  const hotelsUrl = useMemo(() => {
    if (hotelsPageAccess === null || !accessMap[HOTELS].length) {
      return null;
    }

    if (hotelsPageAccess) {
      return `/${HOTELS}`;
    }

    return `/${HOTELS}/${user?.companies[0].id}/${accessMap[HOTELS][0]}`;
  }, [hotelsPageAccess, accessMap, user?.companies]);

  return (
    <div className={styles.container}>
      <div className={styles.pages}>
        {hotelsUrl && (
          <Link className={styles.page} src={hotelsUrl}>
            <div className={styles.svgContainer}>
              <HotelsSvg />
            </div>
            <div className={styles.pageInfo}>
              <div className={styles.title}>{t('page.main.hotels')}</div>
              <div className={styles.description}>
                {t('page.main.hotelsDescription')}
              </div>
            </div>
          </Link>
        )}
        {Boolean(accessMap[REPORTS].length) && (
          <Link
            className={styles.page}
            src={`/${REPORTS}/${accessMap[REPORTS][0]}`}
          >
            <div className={styles.svgContainer}>
              <ReportsSvg />
            </div>
            <div className={styles.pageInfo}>
              <div className={styles.title}>{t('page.main.reports')}</div>
              <div className={styles.description}>
                {t('page.main.reportsDescription')}
              </div>
            </div>
          </Link>
        )}
        {Boolean(accessMap[SERVICE].length) && (
          <Link
            className={styles.page}
            src={`/${SERVICE}/${accessMap[SERVICE][0]}`}
          >
            <div className={styles.svgContainer}>
              <ServiceSvg />
            </div>
            <div className={styles.pageInfo}>
              <div className={styles.title}>{t('page.main.service')}</div>
              <div className={styles.description}>
                {t('page.main.serviceDescription')}
              </div>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
};

export default MainPage;
